import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ColumnType } from '../../../shared/data-table/models/column-type.model';
import { DatatableConfig } from '../../../shared/data-table/models/datatable-config.model';
import { BaseComponent } from '../../../pages/base.component';
import { ContratoArrendamento } from '../../../models/arrendamento/contrato-arrendamento.model';
import { DocumentoService } from '../../../services/documento.service';
import { ModalService } from '../../../services/modal.service';
import { ImageService } from '../../../services/image.service';

@Component({
    selector: 'detalhe-historico',
    templateUrl: 'detalhe-historico-contrato-arrendamento.component.html',
    styleUrls: ['detalhe-historico-contrato-arrendamento.component.scss']
})

export class DetalheHistoricoContratoArrendamentoComponent extends BaseComponent {    
    @Input()
    contrato: ContratoArrendamento;

    @Input()
    index: number;

    public datatableConfig: DatatableConfig =
    {
      actionDisplayName: 'Ações',
      columns:
        [
          { key: 'id', displayName: 'Id', type: ColumnType.Hidden },
          { key: 'filename', displayName: 'Arquivo', type: ColumnType.Text },
          { key: 'descricao', displayName: 'Descrição', type: ColumnType.Text },
          { key: 'dtinclusao', displayName: 'Data de Upload', type: ColumnType.Date },
          {
            key: 'download',
            displayName: 'Download',
            type: ColumnType.Action,
            icon: 'mdi-arrow-down mr-1',
            action: this.download.bind(this),
            //permission: PermissionLevel.Download,
            color: {
              text: '#000',
              background: '#F1C948'
            }
          }
        ]
    };

    constructor(
        protected router: Router,
        private documentoService: DocumentoService,
        private modalService: ModalService,
        private fileService: ImageService
    ) { 
        super(router);
    }

    download(row: any) {
        this.documentoService.downloadDocumento(row.id).subscribe(
            response => {
                const [formato, ...nome] = row.filename.split('.').reverse();
    
                this.fileService.saveData(response, nome[nome.length - 1], formato);
          },
        error => {
            if (error.message) {
                this.modalService.error(error.message);
            } else {
                this.modalService.error('Estamos com problemas técnicos. Tente novamente mais tarde');
            }
        });
    }
}
